import React, { useState } from 'react';
import { Box, Container } from '@mui/material';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import Toolbar from './Toolbar';
import AgingBalanceTabs from './AgingBalanceTabs';
import useStyles from './styles';

const AgingBalanceView = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Page className={classes.root} title={t('NAVIGATION.AGING_BALANCE')}>
      <FadeIn transitionDuration={200}>
        <Container maxWidth={false}>
          <Toolbar tabIndex={tabIndex} />
          <Box mt={3}>
            <AgingBalanceTabs tabIndex={tabIndex} setTabIndex={setTabIndex} />
          </Box>
        </Container>
      </FadeIn>
    </Page>
  );
};

export default AgingBalanceView;
